var $cardSliders,
    $headerSlider;

$(document).ready(function($) {
    $cardSliders = $('.js-card-slider');
    $headerSlider = $('.js-slider-header');

    initCardSliders();
    initHeaderSlider();
});


function initCardSliders() {
    $cardSliders.flickity({
        freeScroll: true,
        contain: true,
        pageDots: false,
        imagesLoaded: true,
        cellAlign: 'left',
    });
}

function initHeaderSlider() {
    var items = $headerSlider.attr('data-items');

    $headerSlider.flickity({
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        groupCells: false,
        prevNextButtons: false,
        autoPlay: $headerSlider.attr('data-speed'),
        initialIndex: Math.floor( Math.random() * items )
    });
}
